module.exports = __webpack_public_path__ + "img/frame (42).1ba1739b.jpg";